import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

type customInputDto = ClientInferResponseBody<typeof contract.quoteRequestLines.customInputs>;

export const fetchCustomInputs = async (): Promise<customInputDto | null> => {
  const response = await api.quoteRequestLines.customInputs.query();

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
